/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import React from 'react';
import { useCombobox } from 'downshift';
import { MagnifyingGlass } from '@td-client-frontend/icons';
import clsx from 'clsx';

interface AutocompleteProps {
  options: string[];
  onSelected: (selectedItem: string | null | undefined) => void;
  onInputValueChange: (value: string | undefined) => void;
}

export function Autocomplete({ options, onInputValueChange, onSelected }: AutocompleteProps) {
  const { isOpen, getToggleButtonProps, getMenuProps, getInputProps, getComboboxProps, getItemProps } =
    useCombobox<string>({
      items: options,
      onSelectedItemChange: ({ selectedItem }) => onSelected(selectedItem),
      onInputValueChange: ({ inputValue }) => onInputValueChange(inputValue)
    });

  return (
    <div>
      <div className='relative field-with-icons' {...getComboboxProps()}>
        <input {...getInputProps()} className='form-field placeholder-gray-default mb-0 border-0 focus:border-0' />
        <button {...getToggleButtonProps()} className='m-0 px-3 bg-primary-600'>
          <MagnifyingGlass className='fill-white' aria-hidden />
        </button>
      </div>
      <ul {...getMenuProps()} className={clsx('overflow-y-auto', options.length && 'h-32')}>
        {isOpen &&
          options.map((item, index) => (
            <li className='p-2' key={`${item}${index}`} {...getItemProps({ item, index })}>
              {item}
            </li>
          ))}
      </ul>
    </div>
  );
}

export default Autocomplete;
